<div class="plan-card__badge u-flex" data-test-id="planCardBadgeWrapper">
  <div class="plan-card__badge__icon" data-test-id="planCardBadgeImageWrapper">
    @if (badge.img) {
      <img data-test-id="planCardBadgeImage" [src]="badge.img" alt="Badge" />
    } @else {
      <div data-test-id="planCardBadgeDefaultIconWrapper">
        @switch (badge.type) {
          @case ('bronze') {
            <svg
              data-test-id="planCardBadgeBronzeIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g fill="none" fill-rule="evenodd">
                <path
                  fill="#F0C8A3"
                  stroke="#D6B291"
                  stroke-width=".875"
                  d="M16,0.505181486 L29.4189065,8.25259074 L29.4189065,23.7474093 L16,31.4948185 L2.58109354,23.7474093 L2.58109354,8.25259074 L16,0.505181486 Z"
                />
                <path
                  fill="#A34410"
                  fill-rule="nonzero"
                  d="M16,8 L9,11.0909091 L9,15.7272727 C9,20.0159091 11.9866667,24.0263636 16,25 C20.0133333,24.0263636 23,20.0159091 23,15.7272727 L23,11.0909091 L16,8 Z M14.4444444,20.3636364 L11.3333333,17.2727273 L12.43,16.1831818 L14.4444444,18.1768182 L19.57,13.0845455 L20.6666667,14.1818182 L14.4444444,20.3636364 Z"
                />
              </g>
            </svg>
          }
          @case ('silver') {
            <svg
              data-test-id="planCardBadgeSilverIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g fill="none" fill-rule="evenodd">
                <path
                  fill="#E5E5E5"
                  stroke="#CCCBCB"
                  d="M16,0.577350269 L29.3564065,8.28867513 L29.3564065,23.7113249 L16,31.4226497 L2.64359354,23.7113249 L2.64359354,8.28867513 L16,0.577350269 Z"
                />
                <path
                  fill="#6E7279"
                  fill-rule="nonzero"
                  d="M16,8 L9,11.0909091 L9,15.7272727 C9,20.0159091 11.9866667,24.0263636 16,25 C20.0133333,24.0263636 23,20.0159091 23,15.7272727 L23,11.0909091 L16,8 Z M14.4444444,20.3636364 L11.3333333,17.2727273 L12.43,16.1831818 L14.4444444,18.1768182 L19.57,13.0845455 L20.6666667,14.1818182 L14.4444444,20.3636364 Z"
                />
              </g>
            </svg>
          }
          @case ('gold') {
            <svg
              data-test-id="planCardBadgeGoldIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g fill="none" fill-rule="evenodd">
                <path
                  fill="#FFD74E"
                  stroke="#E6C247"
                  d="M16,0.577350269 L29.3564065,8.28867513 L29.3564065,23.7113249 L16,31.4226497 L2.64359354,23.7113249 L2.64359354,8.28867513 L16,0.577350269 Z"
                />
                <path
                  fill="#9E7128"
                  d="M16,8 L9,11.0909091 L9,15.7272727 C9,20.0159091 11.9866667,24.0263636 16,25 C20.0133333,24.0263636 23,20.0159091 23,15.7272727 L23,11.0909091 L16,8 Z M14.4444444,20.3636364 L11.3333333,17.2727273 L12.43,16.1831818 L14.4444444,18.1768182 L19.57,13.0845455 L20.6666667,14.1818182 L14.4444444,20.3636364 Z"
                />
              </g>
            </svg>
          }
          @case ('platinum') {
            <svg
              data-test-id="planCardBadgePlatinumIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g fill="none" fill-rule="evenodd">
                <path
                  fill="#F0F3FF"
                  stroke="#C1C8E6"
                  d="M16,0.577350269 L29.3564065,8.28867513 L29.3564065,23.7113249 L16,31.4226497 L2.64359354,23.7113249 L2.64359354,8.28867513 L16,0.577350269 Z"
                />
                <path
                  fill="#5C78AF"
                  fill-rule="nonzero"
                  d="M16,8 L9,11.0909091 L9,15.7272727 C9,20.0159091 11.9866667,24.0263636 16,25 C20.0133333,24.0263636 23,20.0159091 23,15.7272727 L23,11.0909091 L16,8 Z M14.4444444,20.3636364 L11.3333333,17.2727273 L12.43,16.1831818 L14.4444444,18.1768182 L19.57,13.0845455 L20.6666667,14.1818182 L14.4444444,20.3636364 Z"
                />
              </g>
            </svg>
          }
          @case ('csr') {
            <svg
              data-test-id="planCardBadgeCsrIconWrapper"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <defs data-test-id="planCardBadgeCsrIconDefs">
                <path
                  id="badge_csr-a"
                  d="M16.3846154,14.8942857 C14.1525851,14.3157143 13.4337957,13.6857143 13.4337957,12.7471429 C13.4337957,11.6671429 14.4300126,10.9085714 16.0819672,10.9085714 C17.8221942,10.9085714 18.4779319,11.7571429 18.5283733,13.0171429 L20.6847415,13.0171429 C20.6216898,11.2942857 19.5876419,9.71285714 17.5447667,9.19857143 L17.5447667,7 L14.6065574,7 L14.6065574,9.17285714 C12.702396,9.58428571 11.1765448,10.8442857 11.1765448,12.7857143 C11.1765448,15.0871429 13.0554855,16.2442857 15.7919294,16.9128571 C18.2509458,17.5042857 18.7427491,18.3914286 18.7427491,19.3171429 C18.7427491,19.9985714 18.2509458,21.1042857 16.0945776,21.1042857 C14.0769231,21.1042857 13.2824716,20.1785714 13.1689786,18.9957143 L11,18.9957143 C11.1261034,21.1814286 12.7150063,22.4157143 14.6065574,22.8142857 L14.6065574,25 L17.557377,25 L17.557377,22.8528571 C19.4741488,22.48 20.9873897,21.3614286 21,19.2914286 C20.9873897,16.4628571 18.6040353,15.4857143 16.3846154,14.8942857 Z"
                />
              </defs>
              <g
                data-test-id="planCardBadgeCsrIcon"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  fill="#D0F5D0"
                  fill-rule="nonzero"
                  stroke="#A9DEAE"
                  d="M16,0.554958132 L28.07542,6.37017391 L31.0578024,19.4368451 L22.7013525,29.9155019 L9.29864748,29.9155019 L0.942197578,19.4368451 L3.92458002,6.37017391 L16,0.554958132 Z"
                />
                <use
                  fill="#19A64D"
                  fill-rule="nonzero"
                  xlink:href="#badge_csr-a"
                />
              </g>
            </svg>
          }
          @case ('hsa') {
            <svg
              data-test-id="planCardBadgeHsaIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g fill="none">
                <path
                  fill="#FFE4DE"
                  stroke="#E6CDC8"
                  d="M16,0.554958132 L28.07542,6.37017391 L31.0578024,19.4368451 L22.7013525,29.9155019 L9.29864748,29.9155019 L0.942197578,19.4368451 L3.92458002,6.37017391 L16,0.554958132 Z"
                />
                <path
                  fill="#F25735"
                  d="M14.8420537,6 C13.3982445,6 12.2280358,7.15114286 12.2280358,8.57142857 C12.2280358,9.23314286 12.4896963,9.82971429 12.9070678,10.2857143 L16.7770395,10.2857143 C17.1944111,9.82971429 17.4560716,9.23314286 17.4560716,8.57142857 C17.4560716,7.15114286 16.285863,6 14.8420537,6 Z M23.5554468,10.2857143 L20.9958876,11.7974331 C20.3281306,11.3905329 19.5759896,11.0470999 18.737553,10.7929688 L18.5265259,11.4140625 C18.4080238,11.7637767 18.0749813,12 17.6994341,12 L11.9846735,12 C11.6091262,12 11.276084,11.7646339 11.1575819,11.4140625 L11.0895085,11.2114955 C9.59588307,11.9841825 8.58052986,13.1904009 8.13342178,14.6116071 C8.04865725,14.5851359 7.9602726,14.5715861 7.8713393,14.5714286 C7.39011189,14.5714286 7,14.9551845 7,15.4285714 C7,15.9019584 7.39011189,16.2857143 7.8713393,16.2857143 C7.8713393,17.2836643 8.21270887,18.300606 8.80734836,19.2371649 L9.49318763,23.2834817 C9.56289478,23.6974817 9.92652915,24 10.3526141,24 L12.360779,24 C12.7868638,24 13.1504983,23.6974817 13.2202054,23.2834817 L13.3240173,22.6707591 C14.2070191,22.9670194 15.1549752,23.1428571 16.1490627,23.1428571 C16.7542348,23.1428571 17.3422259,23.0932646 17.9104611,23.0039066 L18.2644427,23.5831474 C18.4221552,23.8420046 18.7048368,24 19.0115482,24 L20.9414289,24 C21.491244,24 21.9029248,23.5060174 21.79575,22.9754469 L21.5353694,21.6930806 C22.4084192,21.1495269 23.1201117,20.4759471 23.6201167,19.7142857 L24.6173915,19.7142857 C25.0173363,19.7142857 25.3664846,19.4470174 25.4632032,19.0647326 L25.973754,17.055804 C26.0844141,16.6212317 25.8358236,16.1760266 25.4036393,16.034598 L24.1868271,15.6361611 C23.9513659,14.8829297 23.5439277,14.1484809 22.9785252,13.4765625 C23.2960848,12.6648734 23.5554468,11.6052327 23.5554468,10.2857143 Z M21.8127682,15.4285714 C22.2937475,15.4285714 22.6841075,15.8125714 22.6841075,16.2857143 C22.6841075,16.7588571 22.2937475,17.1428571 21.8127682,17.1428571 C21.3317889,17.1428571 20.9414289,16.7588571 20.9414289,16.2857143 C20.9414289,15.8125714 21.3317889,15.4285714 21.8127682,15.4285714 Z"
                />
              </g>
            </svg>
          }
        }
      </div>
    }
  </div>

  <div class="plan-card__badge__text" data-test-id="planCardBadgeTextWrapper">
    <strong
      class="plan-card__badge__title t-caption t-caps"
      data-test-id="planCardBadgeTitle"
      >{{ badge.title }}</strong
    >
    <p
      class="plan-card__badge__description t-caption t-alt"
      data-test-id="planCardBadgeDescription"
    >
      {{ badge.description }}
    </p>
  </div>
</div>
